import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["variant", "tag", "appearance", "children", "tokens"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { AppearanceProvider, useAppearance } from '@segment/matcha/foundations/AppearanceContext';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import * as views from './Typography.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";

var getElementTag = function getElementTag(variant) {
  switch (variant) {
    case "pExtraLarge":
    case "pExtraLargeBold":
    case "pLarge":
    case "pLargeBold":
    case "pMedium":
    case "pMediumBold":
    case "pSmall":
    case "pSmallBold":
      return "p";

    case "textBold":
    case "textBoldSmall":
    case "textRegularSmall":
    case "textTiny":
    case "buttonLarge":
    case "buttonSmall":
    case "buttonTextLarge":
    case "buttonTextMedium":
    case "buttonTextSmall":
    case "formInput":
    case "formHint":
    case "overline":
      return "span";

    case "formLabel":
      return "label";

    case "code":
      return "pre";

    case "h1":
      return "h1";

    case "h2":
      return "h2";

    case "h3":
      return "h3";

    case "h4":
      return "h4";

    case "h5":
      return "h5";

    case "h6":
      return "h6";

    default:
      throw new Error("Unsupported typography variant \"".concat(variant, "\""));
  }
};

export var BaseTypography = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var variant = _ref.variant,
      tag = _ref.tag,
      externalAppearance = _ref.appearance,
      children = _ref.children,
      tokens = _ref.tokens,
      rest = _objectWithoutProperties(_ref, _excluded);

  var appearance = useAppearance(externalAppearance);
  return _jsx(AppearanceProvider, {
    appearance: appearance,
    children: _jsx(views.Typography, _objectSpread(_objectSpread(_objectSpread({
      as: tag !== null && tag !== void 0 ? tag : getElementTag(variant),
      ref: ref,
      variant: variant
    }, rest), tokens), {}, {
      children: children
    }))
  });
});
export var Typography = withDesignTokens(BaseTypography, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[700],
      linkColor: theme.palette.brand.segmentGreen[500],
      linkHoverColor: theme.palette.brand.segmentGreen[400]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.neutrals.white[100],
      linkColor: theme.palette.brand.darkAcai[400],
      linkHoverColor: theme.palette.brand.darkAcai[500]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100],
      linkColor: theme.palette.twilio.blue[60],
      linkHoverColor: theme.palette.twilio.blue[80]
    };
  },
  twilioDark: function twilioDark(theme) {
    // eslint-disable-next-line no-warning-comments
    // TODO: Replace with twilioDark color
    return {
      color: theme.palette.neutrals.white[100],
      linkColor: theme.palette.twilio.blue[60],
      linkHoverColor: theme.palette.twilio.blue[80]
    };
  },
  cdpWeek2023: function cdpWeek2023(theme) {
    return {
      color: theme.palette.neutrals.white[100],
      linkColor: theme.palette.cdpWeek2023.blue[40],
      linkHoverColor: theme.palette.cdpWeek2023.blue[60]
    };
  }
});